<template>
  <generic-modal :title="$t('billing')" ref="generic_modal" :is_wide="true">
    <div class="container">
      <div class="box box-good">
        <div class="box-header">
          <div class="columns is-mobile">
            <div class="column is-6">
              <figure class="image is-128x128">
                <img class="is-rounded" src="/img/modul/Modul-12.png" />
              </figure>
            </div>
          </div>
        </div>

        <div class="box-content" style="margin-top: -100px">
          <div class="columns is-mobile">
            <div class="column is-8">
              <div class="content">
                <b>{{ $t("reference") }}</b> {{ meta.uuid }}<br />
                <b>{{ $t("date") }}</b> {{ format_date_time(meta.create_date)
                }}<br />
                <b>{{ $t("authorization") }}</b> {{ fel_data.authorization
                }}<br />
                <b>{{ $t("series") }}</b> {{ fel_data.series }}<br />
                <b>{{ $t("number") }}</b> {{ fel_data.number }}<br />
              </div>
            </div>
            <div class="column is-4">
              <div class="content has-text-right">
                <strong
                  >{{ meta.customer.name }} | {{ meta.customer.nit }}</strong
                ><br />
                {{ meta.customer.email }}<br />
                {{ meta.customer.address }} | {{ meta.customer.zip_code }}<br />
                {{ meta.customer.country }} | {{ meta.customer.department }} |
                {{ meta.customer.municipality }}<br />
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12">
              <div class="table-is-responsive">
                <table class="table is-inverse is-fullwidth">
                  <thead>
                    <tr>
                      <th>{{ $t("quantity") }}</th>
                      <th>{{ $t("product") }}</th>
                      <th>{{ $t("price") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, iidx) in meta.items" :key="iidx">
                      <td>{{ item.quantity }}</td>
                      <td>{{ item.name }}</td>
                      <td>
                        {{ item.price }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-7">
              <!-- <span class="icon is-large" style="padding-right: 60px">
                <i class="fa fa-cc-amex"></i>
              </span>
              <span class="icon is-large" style="padding-right: 60px">
                <i class="fa fa-cc-visa"></i>
              </span>
              <span class="icon is-large" style="padding-right: 60px">
                <i class="fa fa-cc-mastercard"></i>
              </span>
              <span class="icon is-large" style="padding-right: 60px">
                <i class="fa fa-cc-paypal"></i> </span
              ><br /><br />
              <div class="notification">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit lorem
                ipsum dolor sit amet, consectetur adipiscing elit
              </div> -->
            </div>
            <div class="column is-5">
              <ul class="list-group list-group-unbordered">
                <li class="list-group-item">
                  <b>{{ $t("total") }}</b>
                  <p class="is-pulled-right">
                    <b>{{ meta.total }}</b>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>{{ meta }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
        v-bind:class="{ 'is-loading': loading }"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <!-- <button class="button is-rounded is-danger" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button> -->
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
  format_date_time,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "EmitterModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: { customer: {} },
      error: "",
    };
  },
  computed: {
    fel_data() {
      let v = this;
      if (v.meta.response_data) {
        if (v.meta.emitter.settings.certifier == "megaprint") {
          let rr =
            v.meta.response_data["dte:GTDocumento"]["dte:SAT"][0]["dte:DTE"][0][
              "dte:Certificacion"
            ][0];
          if (rr["dte:NumeroAutorizacion"]) {
            return {
              authorization: rr["dte:NumeroAutorizacion"][0]["_"],
              series: rr["dte:NumeroAutorizacion"][0]["$"]["Serie"],
              number: rr["dte:NumeroAutorizacion"][0]["$"]["Numero"],
            };
          } else {
            return { authorization: "", series: "", number: "" };
          }
        } else if (v.meta.emitter.settings.certifier == "g4s") {
          return {
            authorization:
              v.meta.response_data.RequestTransactionResult.Response.Identifier
                .DocumentGUID,
            series:
              v.meta.response_data.RequestTransactionResult.Response.Identifier
                .Batch,
            number:
              v.meta.response_data.RequestTransactionResult.Response.Identifier
                .Serial,
          };
        } else {
          return { authorization: "¿?", series: "¿?", number: "¿?" };
        }
      } else return { authorization: "", series: "", number: "" };
    },
  },
  methods: {
    format_date_time,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(billing_uuid) {
      let v = this;
      v.set_initial_state();

      get("/fel/bill", { uuid: billing_uuid })
        .then((billing) => {
          v.meta = billing;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$loader(false);
        });

      v.$refs.generic_modal.show_modal();
    },
    // save() {
    //   let v = this;
    //   let customer_data = v.$refs.customer_info.get_data();
    //   let items_data = v.$refs.items_info.get_data();
    //   let config = {
    //     customer: customer_data,
    //     items: items_data,
    //     emitter_id: 10,
    //   };

    //   v.loading = true;
    //   v.$loader(true);
    //   put("/fel/bill", config)
    //     .then(() => {
    //       v.$emit("success");
    //       v.$refs.generic_modal.close_modal();
    //     })
    //     .catch((error) => {
    //       v.error = generate_error_message_text(error);
    //     })
    //     .finally(() => {
    //       v.loading = false;
    //       v.$loader(false);
    //     });
    // },
    set_initial_state() {
      let v = this;
      v.meta = { customer: {} };
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
